import { useTranslation } from 'react-i18next'
import type { Lesson, Subject } from '../../types/entities'

const DAY_KEYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat'] as const
const SLOTS = [1, 2, 3, 4, 5, 6, 7, 8]

/**
 * Недельная сетка расписания: дни × № урока. Клик по ячейке вызывает
 * onCellClick(day, slot, lesson?) — родитель открывает диалог.
 */
export function ScheduleTable({
  lessonByCell,
  subjectById,
  onCellClick,
}: {
  lessonByCell: Map<string, Lesson>
  subjectById: Map<string, Subject>
  onCellClick: (day: number, slot: number, lesson?: Lesson) => void
}) {
  const { t } = useTranslation()
  return (
    <div className="bg-white border border-gray-200 rounded-xl overflow-auto">
      <table className="w-full text-sm">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-3 py-2 text-left font-semibold text-gray-700 w-16">{t('scheduleTable.slotHeader')}</th>
            {DAY_KEYS.map((k) => (
              <th key={k} className="px-3 py-2 font-semibold text-gray-700 text-center min-w-[140px]">
                {t(`scheduleTable.${k}`)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {SLOTS.map((slot) => (
            <tr key={slot} className="border-t border-gray-100">
              <td className="px-3 py-2 font-semibold text-gray-500 text-center">{slot}</td>
              {[1, 2, 3, 4, 5, 6].map((day) => (
                <LessonCell
                  key={day}
                  lesson={lessonByCell.get(`${day}-${slot}`)}
                  subjectById={subjectById}
                  onClick={(lesson) => onCellClick(day, slot, lesson)}
                />
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

function LessonCell({
  lesson,
  subjectById,
  onClick,
}: {
  lesson?: Lesson
  subjectById: Map<string, Subject>
  onClick: (lesson?: Lesson) => void
}) {
  const { t } = useTranslation()
  const subj = lesson ? subjectById.get(lesson.subjectId) : undefined
  return (
    <td
      onClick={() => onClick(lesson)}
      className="px-2 py-1.5 cursor-pointer hover:bg-primary-soft/30 border-l border-gray-100"
    >
      {lesson && subj ? (
        <div
          className="rounded-md px-2 py-1.5 text-white text-xs leading-tight"
          style={{ background: subj.color ?? '#7c3aed' }}
        >
          <div className="font-semibold truncate">{subj.shortName ?? subj.name}</div>
          {lesson.cabinet && <div className="opacity-75 text-[10px]">{t('scheduleTable.cabinet', { cabinet: lesson.cabinet })}</div>}
          {lesson.startTime && <div className="opacity-75 text-[10px]">{lesson.startTime}</div>}
        </div>
      ) : (
        <span className="text-gray-200 text-xs">+</span>
      )}
    </td>
  )
}

export const SCHEDULE_DAY_KEYS = DAY_KEYS
